class ShoppingCart {

    constructor() {
		this.shoppingBasketId;
		this.country = 'es';
		this.gym;
		this.eftSubscription;
		this.cashSubscription;
		this.addOns = [];
		this.promotionCode;
		this.clipCard = [];
		this.abortController = null;
		this.isFetching = false;
		this.basket = null;
	}

	setShoppingBasketId(shoppingBasketId) {
		this.shoppingBasketId = shoppingBasketId;
	}

	setGym(gym) {
		this.gym = gym;
	}

	setCountry(country) {
		this.country = country;
	}

	setEftSubscription(eftSubscription) {
		this.eftSubscription = eftSubscription;
		this.unsetCashSubscription();
		this.unsetAddOns();
		this.unsetPromotionCode();
		this.unsetClipCard();
	}

	unsetEtfSubscription() {
		this.eftSubscription = null;
	}

	setCashSubscription(cashSubscription) {
		this.cashSubscription = cashSubscription;
		this.unsetEtfSubscription();
		this.unsetAddOns();
		this.unsetPromotionCode();
		this.unsetClipCard();
	}

	unsetCashSubscription() {
		this.cashSubscription = null;
	}

	addAddOn(addOn) {
		if ( !this.addOns.find( item => item === addOn ) ) {
			this.addOns.push(parseInt(addOn));
		}
	}

	unsetAddOns() {
		this.addOns = [];
	}

	setPromotionCode(promotionCode) {
		this.promotionCode = promotionCode;
	}

	unsetPromotionCode() {
		this.promotionCode = null;
	}

	addClipCard(clipCard) {
		if ( !this.clipCard.find( item => item === clipCard ) ) {
			this.clipCard.push(parseInt(clipCard));
		}
	}

	removeClipCard() {
		this.clipCard = [];
	}

	unsetClipCard() {
		this.clipCard = [];
	}

	async process() {
		//console.log(userToken);
		if (this.isFetching) {
			console.error('Aborting previous request');
			this.abortController.abort();
		}

		// Create a new AbortController instance for the current request
		this.abortController = new AbortController();
		const signal = this.abortController.signal;

		this.isFetching = true;

		let params = this.collectParams();
		if ( !params.gym ) {
			console.error('Gym id required');
			return;
		}

		console.log('Creating Basket with params: ',params);

		try {
			const apiClient = new VgApiClient();
			apiClient.action = "create_shopping_basket";
			apiClient.params = { basket_params: params, country: this.country };
			apiClient.signal = signal;
			const response = await apiClient.handleRequest();

			console.log('Created Basket: ',response);
			this.basket = response;
			return response;
		} catch (error) {
			if (error.name === 'AbortError') {
				console.log('Fetch aborted');
			} else {
				console.error("Error creating basket:", error);
			}
		} finally {
			this.isFetching = false;
		}
	}

	collectParams() {
		const params = {
			gym: parseInt(this.gym),
		};

		if (this.eftSubscription) {
			params.eftSubscription = parseInt(this.eftSubscription);
		}

		if (this.cashSubscription) {
			params.cashSubscription = parseInt(this.cashSubscription);
		}

		if (this.addOns.length > 0) {
			params.addOns = this.addOns;
		}

		if (this.promotionCode) {
			params.promotionCode = this.promotionCode;
		}

		if (this.clipCard) {
			params.clipCard = this.clipCard;
		}
		return params;
	}

	getBasketResumeDataTable(data, args) {
		const resultData = {
			"table-edit": args['param-table-edit'],
			"table-head-label": args['param-table-head-label'],
			"table-body": {},
		};

		let voidMonthly = args['param-monthly-void'] ? args['param-monthly-void'] : false;

		data.forEach((fee, index) => {
			let feeLabel = `table-row-${index + 1}`;

			// basketResume only with descount data (no pass day)
			if ((fee.discount) && (fee.name === undefined) && !voidMonthly ) {
				resultData['table-body'][feeLabel] = {
					"table-row-label": args['param-table-label-discount'],
					"table-row-price": fee.discount,
					"table-row-edit": false,
					"table-row-discount": true,
				};
			}

			// basketResume only with discount data on pass day
			if ((fee.discount) && (fee.name === undefined) && voidMonthly ) {
				resultData['table-body'][feeLabel] = {
					"table-row-label": args['param-table-label-discount'],
					"table-row-price": fee.discount,
					"table-row-edit": false,
					"table-row-discount": true,
				};
			}

			if ((fee.price !== undefined) && (fee.name !== undefined)) {

				let asterisk = '';
				args['param-table-extras-label'] ? asterisk = '*' : asterisk = '';

				let isInsuranceProduct = fee.isInsuranceProduct !== undefined ? fee.isInsuranceProduct : false;

				resultData['table-body'][feeLabel] = {
					"table-row-label": fee.name + asterisk,
					"table-row-price": fee.price,
					"table-row-edit": args['param-table-edit-item'],
					"table-row-discount": false,
					"product-id": fee.productKey.id,
					"table-row-insurance": isInsuranceProduct,
				};
				let feeLabelDiscount = args['param-table-label-discount'];
				if (fee.sourceText !== undefined) {
					feeLabelDiscount += ' ' +fee.sourceText + '*';
				}
				if (fee.discount !== 0 && fee.discount !== undefined) {
					resultData['table-body'][feeLabel + '-discount'] = {
						"table-row-label": feeLabelDiscount,
						"table-row-price": fee.discount,
						"table-row-edit": false,
						"table-row-discount": true,
					};
				}

				if (fee.startupCampaignEndDate !== null && fee.startupCampaignEndDate !== undefined) {
					resultData['table-body'][feeLabel + '-promo-code-text'] = {
						"table-row-label": args['param-table-promocode-label'] + ' ' + VgHelpers.formatDate(fee.startupCampaignEndDate),
						"table-row-promo": true,
						"table-row-price": 0,
						"table-row-edit": false,
						"table-row-discount": false,
					};
				}
			}

		});
		args['param-table-extras-label'] ? resultData['table-extras-label'] = args['param-table-extras-label'] : '';
		args['param-table-footer-label'] ? (resultData['table-footer-label'] = args['param-table-footer-label']) : '';
		(Math.abs(args['param-table-footer-total']) >= 0) ? (resultData['table-footer-total'] = args['param-table-footer-total']) : 0;

		resultData['table-head-total'] = this.getBasketCuoteTableFooterTotal(resultData['table-body']);

		// console.log('resultDataSummary: ', resultData);

		return resultData;
	}


	getBasketCuoteDataTable(dataResume, dataBasket, type, category) {
		const resultData = {
			"table-footer-total-price": 0,
			"table-body": {},
		};

		dataResume?.forEach((itemDataResume, index) => {
			const itemDataResumeLabel = `table-row-${index + 1}`;
			if ((!itemDataResume.discount || itemDataResume.name !== undefined) && itemDataResume.productKey !== undefined) {
				resultData['table-body'][itemDataResumeLabel] = {
					"table-row-label": itemDataResume.name,
					"table-row-price": this.getPriceBasketSubscriptionById(dataBasket.products, itemDataResume.productKey.id, type, category),
					"product-id": itemDataResume.productKey.id,
				};
			}
		});
		resultData['table-footer-total-price'] = this.getBasketCuoteTableFooterTotal(resultData['table-body']);
		return resultData;
	}

	getPriceBasketSubscriptionById(products, id, type, category) {

		let resultPrice = 0;
		products.forEach(product => {
			if (product.productKey.id === id) {
				switch (type) {
					case 'monthly':
						switch (category) {
							case 'fee':
								resultPrice = product.price.normalPeriodPrice;
								break;
							case 'extras':
								resultPrice =  product.price.normalPeriodPrice ? product.price.normalPeriodPrice : product.price.normalPrice;
								// TODO: Ojo en el else Ale me ha dicho que es price, pero creo que no, mirar Taquilla
								break;
						}
						break;
					case 'paynow':
						resultPrice = product.price.price;
						break;
				}
			}
		});

		return resultPrice;
	}

	getBasketCuoteTableFooterTotal (data) {
		let footerTotal = 0;
		if (Object.keys(data).length > 0) {
			Object.keys(data).forEach((key) => {
				footerTotal += data[key]['table-row-price'];
			});
		}
		return footerTotal;
	}

	showErrorModalClipcard() {
		new VgModal({
			title: JoiningVars.get_form_field("modals").joining_summary_clipcard.title,
			description: JoiningVars.get_form_field("modals").joining_summary_clipcard.content,
			data: [],
			type: "error",
			template: "basic",
		});
	}

	showErrorModalBasket() {
		new VgModal({
			title: JoiningVars.get_form_field("modals").controller_basket.title,
			description: JoiningVars.get_form_field("modals").controller_basket.content,
			data: [],
			type: "error",
			template: "basic",
		});
	}
}

export { ShoppingCart };
